import { useState } from 'react'

import { $generateHtmlFromNodes } from '@lexical/html'

import { TemplateEntity } from '@eastcoal/api/contract/interface'
import { createTemplateApi } from '@eastcoal/api/contract/template/createTemplate'
import { updateTemplateApi } from '@eastcoal/api/contract/template/updateTemplate'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useEditor } from '@eastcoal/editor/hooks/useEditor'

import { getTemplateName } from '../../../utils/getTemplateName'
import { useContractDesignerStore } from '../../Store/hooks/useStore'

const updateUrl = (template: TemplateEntity) => {
  const url = new URL(window.location.href)
  url.searchParams.set('id', `${template.id}`)
  history.pushState({}, document.title, url)
}

export const SubmitButton = () => {
  const { formData, updateFormData } = useContractDesignerStore(state =>
    pick(state, ['formData', 'updateFormData'])
  )

  const editor = useEditor()
  const { message } = useFeedback()
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    try {
      setLoading(true)
      formData.name = getTemplateName(formData.name)
      editor.getEditorState().read(() => {
        formData.jsonContent = JSON.stringify(editor.getEditorState().toJSON())
        formData.htmlContent = $generateHtmlFromNodes(editor, null)
      })
      const api = formData.id ? updateTemplateApi : createTemplateApi
      const res = await api(formData)
      updateUrl(res)
      updateFormData(res)
      message.success('保存成功', 1)
    } finally {
      setLoading(false)
    }
  }

  return (
    <ThrottleButton loading={loading} type='primary' onClick={handleClick}>
      保存
    </ThrottleButton>
  )
}
